/**
 * Streaming endpoints for real-time updates
 */

import type { RouteContext } from '../types';
import { createStreamResponse } from '../responses';

export async function streamHandler(context: RouteContext): Promise<Response> {
  const { request, requestId } = context;
  
  if (request.method !== 'GET') {
    throw new Error('Streaming endpoint only supports GET requests');
  }

  const url = new URL(request.url);
  const path = url.pathname;

  if (path.includes('/tasks/stream')) {
    return createTasksStream(context);
  }

  throw new Error('Unknown streaming endpoint');
}

function createTasksStream(context: RouteContext): Response {
  const { requestId } = context;

  return createStreamResponse(requestId, async (send) => {
    // Send initial connection message
    send({
      type: 'connected',
      message: 'Task stream connected',
      timestamp: new Date().toISOString(),
    });

    // Send initial tasks
    send({
      type: 'tasks',
      tasks: [],
      timestamp: new Date().toISOString(),
    });

    // Set up periodic updates (in a real implementation, this would be event-driven)
    let updateCount = 0;
    const interval = setInterval(() => {
      updateCount++;
      
      send({
        type: 'update',
        message: `Heartbeat ${updateCount}`,
        timestamp: new Date().toISOString(),
      });

      // Stop after 10 updates for demo purposes
      if (updateCount >= 10) {
        clearInterval(interval);
      }
    }, 5000);

    // Cleanup after 60 seconds
    setTimeout(() => {
      clearInterval(interval);
      send({
        type: 'disconnect',
        message: 'Stream ending',
        timestamp: new Date().toISOString(),
      });
    }, 60000);
  });
}